import _extends from "@babel/runtime/helpers/extends";
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { getOverrides, useClasses } from '../../../utils/overrides';
import { createUseStyles } from '../../../utils/styles';
import Icon from '../Icon';
import styles from './styles';
const useStyles = createUseStyles(styles, 'IconMultiple');
const SIZES = ['huge', 'big', 'large', 'medium', 'small'];
function IconMultiple(_ref) {
  let {
    classes: classesProp,
    overrides: overridesProp,
    className: classNameProp,
    size = 'medium',
    firstIcon,
    firstProps = {},
    secondIcon,
    secondProps = {},
    ...props
  } = _ref;
  const classes = useClasses(useStyles, classesProp);
  // Overrides
  const override = getOverrides(overridesProp, IconMultiple.overrides);

  // Classes
  const rootClassName = classnames(classes.root, classNameProp, classes[size]);
  const secondSize = useMemo(() => {
    const index = SIZES.findIndex(s => size === s);
    return SIZES[index + 1] || 'small';
  }, [size]);
  const rootProps = {
    ...props,
    className: rootClassName
  };
  return /*#__PURE__*/React.createElement("div", _extends({}, rootProps, override.root), /*#__PURE__*/React.createElement(Icon, _extends({
    name: firstIcon,
    size: size,
    className: classes.FirstIcon
  }, override.FirstIcon, firstProps)), /*#__PURE__*/React.createElement(Icon, _extends({
    name: secondIcon,
    className: classes.SecondIcon,
    size: secondSize
  }, override.SecondIcon, secondProps)));
}
IconMultiple.overrides = ['root', 'FirstIcon', 'SecondIcon'];
process.env.NODE_ENV !== "production" ? IconMultiple.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  overrides: PropTypes.object,
  firstIcon: PropTypes.string.isRequired,
  secondIcon: PropTypes.string.isRequired
} : void 0;
export default /*#__PURE__*/React.memo(IconMultiple);